var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHashtagIconFb(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 36,
    viewBox: "0 0 20 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1838 6.55731C11.4373 7.57328 11.1372 9.19389 11.1372 11.653V33.2776C11.1372 34.5573 10.0601 35.5946 8.73153 35.5946C7.40292 35.5946 6.32586 34.5573 6.32586 33.2776L6.32586 11.653C6.32586 9.12171 6.56707 6.17959 8.25633 3.88045C10.0873 1.38846 13.1532 0.210571 17.392 0.210571C18.7206 0.210571 19.7976 1.24793 19.7976 2.52758C19.7976 3.80723 18.7206 4.84459 17.392 4.84459C14.0528 4.84459 12.7885 5.73419 12.1838 6.55731Z",
    fill: "#F3EDD8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.202332 14.9069C0.202332 13.5542 1.23043 12.4575 2.49866 12.4575H17.5013C18.7695 12.4575 19.7976 13.5542 19.7976 14.9069C19.7976 16.2597 18.7695 17.3563 17.5013 17.3563H2.49866C1.23043 17.3563 0.202332 16.2597 0.202332 14.9069Z",
    fill: "#F3EDD8"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHashtagIconFb);
export default __webpack_public_path__ + "static/media/hashtag_icon_fb.6206c6d30585c9fb3ee26bc55b0495ac.svg";
export { ForwardRef as ReactComponent };